"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (fn) {
    var cleanup = function () {
        try {
            fn();
        }
        finally {
            process.exit();
        }
    };
    process.on('exit', cleanup);
    process.on('SIGINT', cleanup);
    process.on('SIGTERM', cleanup);
    process.on('SIGHUP', cleanup);
    process.on('SIGBREAK', cleanup);
});
